(function () {
  const SWIPER_ATTR = 'data-trust-badges-swiper-initialized';
  const MOBILE_MAX = 767;

  function parseBool(value) {
    return value === 'true' || value === true;
  }

  function parseSlides(value, fallback) {
    const n = parseFloat(value);
    return Number.isFinite(n) && n > 0 ? n : fallback;
  }

  function destroyTrustBadgesSwipers(root) {
    const scope = root || document;
    scope.querySelectorAll(`[data-trust-badges-slider][${SWIPER_ATTR}]`).forEach((slider) => {
      if (slider.__trustBadgesSwiper) {
        slider.__trustBadgesSwiper.destroy(true, true);
        slider.__trustBadgesSwiper = null;
      }
      slider.removeAttribute(SWIPER_ATTR);
    });
  }

  function initTrustBadgesSwiper(slider) {
    if (!slider || slider.hasAttribute(SWIPER_ATTR) || typeof window.Swiper === 'undefined') return;

    const sectionEl = slider.closest('[data-trust-badges-section]') || slider.closest('.trust-badges');
    if (!sectionEl) return;

    const { arrows, dots, autoplay, autoplaySpeed, infinite } = slider.dataset;
    const slidesDesktop = parseSlides(sectionEl.dataset.slidesDesktop, 3);
    const slidesMobile = parseSlides(sectionEl.dataset.slidesMobile, 3);

    const prev = sectionEl.querySelector('[data-trust-badges-prev]');
    const next = sectionEl.querySelector('[data-trust-badges-next]');
    const paginationEl = slider.querySelector('.trust-badges__pagination');

    const config = {
      slidesPerView: slidesMobile,
      spaceBetween: 0,
      watchOverflow: true,
      loop: parseBool(infinite),
      breakpoints: {
        [MOBILE_MAX + 1]: {
          slidesPerView: slidesDesktop,
        },
      },
    };

    if (parseBool(arrows) && prev && next) {
      config.navigation = { prevEl: prev, nextEl: next };
    }

    if (parseBool(dots) && paginationEl) {
      config.pagination = { el: paginationEl, clickable: true };
    }

    if (parseBool(autoplay)) {
      config.autoplay = {
        delay: (parseInt(autoplaySpeed, 10) || 5) * 1000,
        disableOnInteraction: false,
      };
    }

    slider.__trustBadgesSwiper = new window.Swiper(slider, config);
    slider.setAttribute(SWIPER_ATTR, 'true');
  }

  function initTrustBadgesSwipers(root) {
    const scope = root || document;
    scope.querySelectorAll(`[data-trust-badges-slider]:not([${SWIPER_ATTR}])`).forEach(initTrustBadgesSwiper);
  }

  function whenSwiperReady(cb) {
    if (typeof window.Swiper !== 'undefined') {
      cb();
      return;
    }

    const started = Date.now();
    const timer = setInterval(() => {
      if (typeof window.Swiper !== 'undefined') {
        clearInterval(timer);
        cb();
      } else if (Date.now() - started > 8000) {
        clearInterval(timer);
      }
    }, 50);
  }

  function onReady(root) {
    whenSwiperReady(() => initTrustBadgesSwipers(root));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => onReady());
  } else {
    onReady();
  }

  if (!window.__trustBadgesEventsBound) {
    window.__trustBadgesEventsBound = true;

    document.addEventListener('shopify:section:load', (event) => {
      onReady(event.target);
    });

    document.addEventListener('shopify:section:unload', (event) => {
      destroyTrustBadgesSwipers(event.target);
    });
  }
})();
